export function getFirstName(name: string | null | undefined) {
  return name?.trim().split(/\s+/)[0] ?? null;
}
